export enum DictionaryType {
  ReachType = 'reachType',
  Affiliation = 'affiliation',
  BusinessUnit = 'businessUnit',
  Pharma = 'pharma',
  Brand = 'brand',
  Series = 'series',
  DeliverableID = 'deliverableID',
  Countries = 'countries',
  States = 'states',
}

export interface GetDictionariesRequest {
  dictionaryType: DictionaryType;
  pharma?: number;
  brand?: number;
  series?: number;
}

export interface GetDictionariesResponse {
  data: {
    display_name: string;
    id: number | string;
    name: string;
    default?: boolean;
    mandatory?: boolean;
  }[];
  eventID: string;
  staticDictionary?: boolean;
}

export interface GetDeliveryIdDetailsRequest {
  dictionary: MedscapeConsentDictionaryType.Deliverable;
  deliverable: string;
}
export interface GetDeliveryIdDetailsResponse {
  data: {
    BRAND_ID: number;
    BRAND_NAME: string;
    DELIVERABLE_ID: string;
    PHARMA_ID: number;
    PHARMA_NAME: string;
    PROMO_ACTIVITY_ID: number;
    SERIES_ID: number;
    SERIES_NAME: string;
  };
  eventID: string;
}

export enum MedscapeConsentDictionaryType {
  BusinessUnit = 'bu',
  BusinessVertical = 'bv',
  Brand = 'brand',
  Pharma = 'pharma',
  Product = 'product',
  DeliverableIds = 'deliverable_ids',
  Deliverable = 'deliverable',
  Countries = 'countries',
  States = 'states',
}

export interface GetMedscapeConsentDictionariesRequest {
  dictionary: MedscapeConsentDictionaryType;
  businessUnit?: number;
  businessVertical?: number;
  pharma?: number;
  deliverable?: string;
}
